module.exports = __webpack_public_path__ + "img/genderGapReport.5479990a.svg";